import { formatDate } from 'helpers/dateHelper';
import {
    RetrospectivePayComponentSalaryMassData,
    RetrospectiveSalaryMassData,
} from '../../helpers/retrospectiveData';

type SalaryMassAmountsType = {
    uniqueAgentsCount: number;
    uniqueAgentsCountWithAmounts: number;
    etp: number;
    etpt: number;
};
type SalaryMassEvolutionType = {
    levelPercentage: number;
    levelIndice: number;
    massPercentage: number;
    massIndice: number;
    reportIndice: number;
    reportAmount: number;
};
export const getAmounts = ({
    data,
}: {
    data: RetrospectiveSalaryMassData;
}): SalaryMassAmountsType => {
    return {
        etp: data.etp,
        uniqueAgentsCount: data.uniqueAgentsCount,
        uniqueAgentsCountWithAmounts: data.uniqueAgentsCountWithAmounts,
        etpt: data.etpt,
    };
};

export const getEvolutionAmounts = ({
    data,
}: {
    data: RetrospectivePayComponentSalaryMassData;
}): SalaryMassEvolutionType => {
    const monthLevelEvolution =
        data.payComponentTotalLastMonthCurrentYear -
        data.payComponentTotalLastMonthPreviousYear;
    const levelPercentage =
        data.payComponentTotalLastMonthPreviousYear === 0
            ? 0
            : (monthLevelEvolution /
                  data.payComponentTotalLastMonthPreviousYear) *
              100;
    const levelIndice =
        data.payComponentTotalLastMonthPreviousYear === 0
            ? 0
            : data.payComponentTotalLastMonthCurrentYear /
              data.payComponentTotalLastMonthPreviousYear;

    const massLevelEvolution =
        data.payComponentSalaryMassCurrentYear -
        data.payComponentTotalLastMonthPreviousYear * 12;
    const massPercentage =
        data.payComponentTotalLastMonthPreviousYear === 0
            ? 0
            : (massLevelEvolution /
                  (data.payComponentTotalLastMonthPreviousYear * 12)) *
              100;
    const massLeveLIndice =
        data.payComponentTotalLastMonthPreviousYear === 0
            ? 0
            : data.payComponentSalaryMassCurrentYear /
              (data.payComponentTotalLastMonthPreviousYear * 12);

    const reportIndice =
        data.payComponentSalaryMassPreviousYear === 0
            ? 0
            : (data.payComponentTotalLastMonthCurrentYear * 12) /
              data.payComponentSalaryMassCurrentYear;

    const reportAmount =
        data.payComponentSalaryMassCurrentYear *
            parseFloat(reportIndice.toFixed(2)) -
        data.payComponentSalaryMassCurrentYear;

    return {
        levelPercentage: levelPercentage || 0,
        levelIndice: levelIndice || 0,
        massPercentage: massPercentage || 0,
        massIndice: massLeveLIndice || 0,
        reportIndice: reportIndice || 0,
        reportAmount: reportAmount || 0,
    };
};

export const getRemuneratedEffectiveRange = ({
    exercice,
}: {
    exercice: number;
}): [string, string] => {
    const startDate = formatDate(new Date(exercice, 11, 1));
    const endDate = formatDate(new Date(exercice, 11, 31));
    return [startDate, endDate];
};
